import { ActiveFiltersBadges } from '@/components/ui/ActiveFiltersBadges';
import { Button } from '@/components/ui/Button';
import { CardBox } from '@/components/ui/CardBox';
import { Icon } from '@/components/ui/Icon';
import { mdiFilter } from '@mdi/js';
import * as React from 'react';

const ENABLED_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Enabled' },
  { value: 'false', label: 'Disabled' },
];

const PLATFORM_OPTIONS = [
  { value: '', label: 'All Platforms' },
  { value: 'ios', label: 'iOS' },
  { value: 'android', label: 'Android' },
];

export interface AppVersionsFiltersProps {
  selectedEnabled: string;
  selectedPlatform: string;
  onEnabledChange: (value: string) => void;
  onPlatformChange: (value: string) => void;
  onClearFilters: () => void;
}

export const AppVersionsFilters: React.FC<AppVersionsFiltersProps> = ({
  selectedEnabled,
  selectedPlatform,
  onEnabledChange,
  onPlatformChange,
  onClearFilters,
}) => {
  const activeFilters = [
    {
      label: 'Platform',
      value: selectedPlatform
        ? selectedPlatform === 'ios'
          ? 'iOS'
          : 'Android'
        : '',
      color: 'purple' as const,
    },
    {
      label: 'Status',
      value: selectedEnabled
        ? selectedEnabled === 'true'
          ? 'Enabled'
          : 'Disabled'
        : '',
      color: 'green' as const,
    },
  ];

  return (
    <CardBox className='p-6'>
      <div className='space-y-4'>
        <div className='flex items-center space-x-2'>
          <Icon path={mdiFilter} size={20} className='text-grey-500' />
          <span className='text-sm font-medium text-grey-700'>Filters:</span>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
          <div>
            <label className='block text-sm font-medium text-grey-700 mb-1'>
              Platform
            </label>
            <select
              value={selectedPlatform}
              onChange={e => onPlatformChange(e.target.value)}
              className='w-full px-3 py-2 border border-grey-300 rounded-md bg-white text-grey-900 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            >
              {PLATFORM_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className='block text-sm font-medium text-grey-700 mb-1'>
              Status
            </label>
            <select
              value={selectedEnabled}
              onChange={e => onEnabledChange(e.target.value)}
              className='w-full px-3 py-2 border border-grey-300 rounded-md bg-white text-grey-900 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            >
              {ENABLED_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className='flex items-end'>
            <Button
              type='button'
              label='Clear Filters'
              color='light'
              onClick={onClearFilters}
              className='w-full'
            />
          </div>
        </div>

        <ActiveFiltersBadges filters={activeFilters} />
      </div>
    </CardBox>
  );
};
